import packageJson from '../../../package.json';

const _VERSION_FIELD_NAME = '__version__';
const _VERSION_FIELD_DEFAULT_VALUE = '';

function getAppVersion() {
  return (
    window.localStorage.getItem(_VERSION_FIELD_NAME) ||
    _VERSION_FIELD_DEFAULT_VALUE
  );
}

function setAppVersion(version: string) {
  window.localStorage.setItem(_VERSION_FIELD_NAME, version);
}

function getPackageVersion() {
  return packageJson.version;
}

// Per-deploy build identifier baked into the bundle at build time (see
// vite.config.js `define`); changes every deploy. Falls back to package.json's
// version in dev, where it is not injected. Used only to detect new deployments.
function getBuildVersion() {
  return import.meta.env.VITE_APP_VERSION || packageJson.version;
}

// URL of the deploy-version marker, served alongside the built assets (mirrors
// how `renderBuiltUrl` in vite.config.js prefixes asset URLs with VITE_BUILD_URL).
function getVersionUrl() {
  return `${import.meta.env.VITE_BUILD_URL || '/'}dist/version.json`;
}

// Fetches the currently deployed version from the server, bypassing all caches.
async function fetchDeployedVersion(): Promise<string> {
  const response = await fetch(getVersionUrl(), { cache: 'no-store' });
  if (!response.ok) {
    throw new Error(`Failed to fetch version.json: ${response.status}`);
  }
  const data: { version?: string } = await response.json();
  if (!data.version) {
    throw new Error('version.json is missing a version field');
  }
  return data.version;
}

export {
  _VERSION_FIELD_DEFAULT_VALUE,
  _VERSION_FIELD_NAME,
  fetchDeployedVersion,
  getAppVersion,
  getBuildVersion,
  getPackageVersion,
  getVersionUrl,
  setAppVersion,
};
